let isLoaded = false;

export const loadSuperchat = () => {
    if (isLoaded || typeof window === "undefined") return;

    const script = document.createElement("script");
    script.src =
        "https://widget.superchat.de/snippet.js?applicationKey=WCw1eoQpN7v9WJV4r82laD63KR";
    script.async = true;
    script.referrerPolicy = "no-referrer-when-downgrade";

    document.body.appendChild(script);

    isLoaded = true;
};